// extracted by mini-css-extract-plugin
export default {"active":"styles_active__N-PpC","input_text":"styles_input_text__HtLcT"};